import {
    Grid, makeStyles,
} from '@material-ui/core';
import { useState, Suspense } from 'react';

import { TitledAppBar } from 'src/components/common/TitledAppBar';
import { SearchResultsContainer } from 'src/components/common/Search/SearchResultsContainer';
import { FacetedSearch } from 'src/components/common/Search/FacetedSearch';
import { CategoryResults } from 'src/components/Categories/CategoryResults';
import { ResultsSkeleton } from 'src/components/common/skeletons/ResultsSkeleton';
import { ErrorBoundary } from 'src/components/common/ErrorBoundary';
import { SEARCH_KEYWORDS_PLACEHOLDER } from 'src/components/common/Search/constants';
import { CATEGORY_NAME_FACET, FACETS } from 'src/components/Categories/constants';

const useStyles = makeStyles({
    container: {
        gridArea: 'content',
    },
});

export const CategoriesPage = (): JSX.Element => {
    const classes = useStyles();
    const [search, setSearch] = useState<App.Categories.Search>({} as App.Categories.Search);

    const handleSubmit = (facetedSearch: FacetedSearch.FacetedSearchResult): void => {
        const newSearch = {
            ids: facetedSearch.ids as string[],
            keys: facetedSearch.keys as string[],
            internalName: facetedSearch.internalName as string,
        };

        setSearch(newSearch);
    };

    return (
        <>
            <TitledAppBar title="Categories">
                <Grid
                    container
                    justifyContent="center"
                    spacing={2}
                    wrap="nowrap"
                >
                    <Grid item xs={10}>
                        <FacetedSearch
                            defaultFacet={CATEGORY_NAME_FACET}
                            facets={FACETS}
                            label="Search Categories"
                            placeholder={SEARCH_KEYWORDS_PLACEHOLDER}
                            onSubmit={handleSubmit}
                        />
                    </Grid>
                </Grid>
            </TitledAppBar>
            <SearchResultsContainer className={classes.container}>
                <ErrorBoundary>
                    <Suspense fallback={<ResultsSkeleton />}>
                        <CategoryResults search={search} />
                    </Suspense>
                </ErrorBoundary>
            </SearchResultsContainer>
        </>
    );
};
